
import { defineComponent, watch, PropType, ref, toRefs } from 'vue';
import { ElSelect, ElOption, ElButton } from 'element-plus';

import { useStore } from '@/store';

import { GenreStyleId, GenreStyleModel, GenreStyleType } from '@/typings';
// TODO 有bug 。。。 编年史那里测出来的
export default defineComponent({
    components: {
        ElSelect,
        ElOption,
        ElButton
    },
    props: {
        styles: {
            type: Array as PropType<GenreStyleModel[] | GenreStyleId[]>,
            default: () => {
                return [];
            }
        },
        addbtn: {
            type: Boolean,
            default: false
        },
        multiple: {
            type: Boolean,
            default: false
        }
    },
    emits: {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        change (val:string | string[]) {
            return true;
        }
    },
    setup (props) {
        const {
            multiple,
            styles
        } = toRefs(props);

        const inputValue = ref<string | string[]>('');

        const filteredstyles = ref<Array<Omit<GenreStyleModel, 'type'>& {
            type:GenreStyleType
        }>>([]);
        const loading = ref(false);
        const filterstyle = (query:string) => {
            loading.value = true;
            const _tmp_hash_style:Record<string, boolean> = {};
            if (query !== '') {
                let counter = 0;
                filteredstyles.value = [];

                query = query.toLowerCase();
                for (const _id in store.state.genre_styles) {
                    const item = store.state.genre_styles[_id];
                    if (
                        item.name.toLowerCase().includes(query) ||
      item.name_orig.toLowerCase().includes(query) ||
      item.name_alt.toLowerCase().includes(query)
                    ) {
                        if (!_tmp_hash_style[_id]) {
                            _tmp_hash_style[_id] = true;

                            filteredstyles.value.push(item);
                        }
                    }
                    if (filteredstyles.value.length >= 15) {
                        break;
                    }
                }
                if (filteredstyles.value.length < 5) {
                    counter = 5 - filteredstyles.value.length;
                    for (const _id in store.state.genre_styles) {
                        if (counter <= 0) {
                            break;
                        }
                        counter--;
                        if (!_tmp_hash_style[_id]) {
                            _tmp_hash_style[_id] = true;
                            filteredstyles.value.push(store.state.genre_styles[_id]);
                        }
                    }
                }
            } else {
                filteredstyles.value = [];
                let counter = 5;
                for (let k = 0; k < inputValue.value.length; k++) {
                    const _id = inputValue.value[k];
                    if (!_tmp_hash_style[_id]) {
                        _tmp_hash_style[_id] = true;
                        filteredstyles.value.push(store.state.genre_styles[_id]);
                    }

                    counter--;
                }
                for (const _id in store.state.genre_styles) {
                    if (counter <= 0) {
                        break;
                    }
                    counter--;
                    if (!_tmp_hash_style[_id]) {
                        _tmp_hash_style[_id] = true;
                        filteredstyles.value.push(store.state.genre_styles[_id]);
                    }
                }
            }
            loading.value = false;
        };

        const store = useStore();
        const initInput = () => {
            if (multiple.value) {
                inputValue.value = styles.value.map(item => {
                    if (typeof item === 'object') {
                        return item._id;
                    } else {
                        return item;
                    }
                });
            }
            filterstyle('');
        };

        if (!store.state.genre_styles_cached) {
            watch(() => store.state.genre_styles_cached, initInput);
            store.dispatch('fetchCatelog', false);
        } else {
            initInput();
        }

        const inputVisible = ref(false);
        const showInput = () => {
            inputVisible.value = true;
        };

        return {
            inputValue,
            filteredstyles,
            loading,
            showInput,
            filterstyle
        };
    }
});
